import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { useAdminStats } from '@/hooks/useAdmin'

export default function AdminStatsCards() {
  const { stats, loading } = useAdminStats()

  const cards = [
    { label: 'Total de Notícias', value: stats.totalNews, icon: 'ri-article-line', color: 'bg-alvinegro-black text-white' },
    { label: 'Publicadas', value: stats.publishedNews, icon: 'ri-check-double-line', color: 'bg-green-600 text-white' },
    { label: 'Rascunhos', value: stats.draftNews, icon: 'ri-draft-line', color: 'bg-yellow-500 text-white' },
    { label: 'Usuários', value: stats.totalUsers, icon: 'ri-team-line', color: 'bg-alvinegro-dark text-white' },
    { label: 'Comentários', value: stats.totalComments, icon: 'ri-chat-3-line', color: 'bg-gray-500 text-white' },
    { label: 'Visualizações', value: stats.totalViews, icon: 'ri-eye-line', color: 'bg-alvinegro-black text-white' },
    { label: 'Pendentes Clipagem', value: stats.pendingClips, icon: 'ri-rss-line', color: 'bg-red-500 text-white', highlight: stats.pendingClips > 0 },
  ]

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-4"
    >
      {cards.map((card) => (
        <div key={card.label} className={`rounded-xl p-4 ${card.color} ${card.highlight ? 'ring-2 ring-red-300 animate-pulse' : ''}`}>
          <div className="flex items-center justify-between mb-2">
            <i className={`${card.icon} text-lg opacity-80`}></i>
            <span className="text-2xl font-bold">{loading ? '-' : card.value}</span>
          </div>
          <p className="text-xs opacity-80">{card.label}</p>
        </div>
      ))}
    </div>
  )
}